/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosError } from 'axios';
import { Api } from '../../axiosApi';
import { Environment } from '../../../../environment';

export interface IListagemMovimento {
  idmov: string;
  emissao: string;
  descricao: string;
  cpf: string;
  nome: string;
  numero: string;
  total: number;
}
export interface IListagemDashboardComissao {
  vendas: string;
  total: number;
  comissao: number;
}
export interface IitensMovimentoDialog {
  iditens: string;
  idprodutos: string;
  idref: string;
  qtds: number;
  qtde: number;
  un: string;
  preco: number;
  localizado?: string;
  original?: boolean;
  ean?: string;
  desconto: number;
  voutros: number;
  subtotal: number;
  total: number;
  filtro: string;
  referencia?: string;
  marca?: string;
  status?: number;
  descricao: string;
}
export interface IempresaImpressao {
  idempresa: string;
  nome: string;
  cnpj: string;
  fantasia: string;
  logo: string;
  endereco: string;
  numero: string;
  bairro: string;
  uf: string;
  telefone: string;
  cidade: string;
}
interface IgetMovimento {
  idmov: string;
  idparceiro: string;
  idplanoconta: string;
  iduser: string;
  numero: string;
  faturado: boolean;
  idoperacao: string;
  emissao: string;
  caixa: string;
  recebidas: string;
  nome: string;
  total: number;
  desconto: number;
  vendedor: string;
  vprod: number;
  acrescimo: number;
  itens: IitensMovimentoDialog[];
}
interface IgetImpressao {
  idmov: string;
  dataoperacao: string;
  numero: string;
  total: number;
  vprod: number;
  desconto: number;
  acrescimo: number;
  cidade?: string;
  vendedor?: string;
  celular?: string;
  telefone?: string;
  cep?: string;
  nome?: string;
  endereco?: string;
  logo?: string;
  empresa: IempresaImpressao[];
  itens: IitensMovimentoDialog[];
}
interface IDetalheMovimento {
  idmov: string;
  idparceiro: string;
  idplanoconta: string;
  idoperacao: string;
  numero: string;
  emissao: string;
  total: number;
  desconto: number;
  vprod: number;
  acrescimo: number;
  obs?: string;
}
interface IDetalheMovimentoupdate {
  idparceiro: string;
  idplanoconta: string;
  idoperacoes: string;
  emissao: Date;
  numero: string;
  total: number;
  desconto: number;
  vprod: number;
  acrescimo: number;
}

interface IItensids {
  iditens: string;

}

interface IItensidsDevolucao {
  iditens: string;
  idmov: string;
  idprodutos: string;
  un: string;
  qtde: number;
  subtotal?: number;
  desconto?: number;
  voutros?: number;
  qtds: number;
  total?: number;
}

interface IParcelasFaturamento {
  idrec: string;
  idplanoconta: string;
  emissao: string;
  vencimento: string;
  pagamento: string;
  tipo: number;
  parcela: string;
  vreceber: number;
  historico: string;
  juros: number;
  desconto: number;
  acrescimo: number;
  vrecebido: number;
  vparcela: number;
  venda: number;
  qtdparcelas: number;
}

type TotalCount = {
  data: IListagemMovimento[];
  totalCount: number;
}
export interface IComissaoItem {
  numero: string;
  nome: string;
  comissao: number;
  emissao: string;
}

export interface TotalCountComissao {
  vendedor: boolean;
  tipovenda: {
    avista: number;
    aprazo: number;
  },
  totais: {
    vendas: string;
    total: number;
    comissao: number;
  };

  comissao: IComissaoItem[];
}


interface ErrorResponse {
  errors: {
    default: string;
  };
}
interface ErrorResponsedevolucao {
  errors: string;
}
export interface IVendaComissao {
  numero: string;
  nome: string;
  total: number;
  comissao: number;
  status: string;
}

export interface IListagemVendasComissao {
  vendas: IVendaComissao[];
  totalCount: number;
}
export interface IGraficoComissaoItem {
  emissao: string;
  valor: number;
  comissao: number;
}
export interface IGraficoVendasComissao {
  grafico: IGraficoComissaoItem[];
}

export interface IVendedorDashboardVendas {
  nome: string;
  vendas: string;
  total: number;
  comissao: number;
}

export interface IGraficoDashboardVendas {
  emissao: string;
  valor: number;
}

export interface IDashboardVendas {
  vendedores: IVendedorDashboardVendas[];
  tipovenda: {
    avista: number;
    aprazo: number;
  };
  grafico: IGraficoDashboardVendas[];
}

export type TPeriodoDashboardVendas = 'mensal' | 'trimestral' | 'semestral' | 'anual' | 'atual';

export interface IEvolucaoVendasItem {
  periodo: string;
  ano: 'atual' | 'anterior';
  receita: number;
  vendas: string;
  ticketmedio: number;
}

export interface IFormaPagamentoItem {
  forma: string;
  receita: number;
  vendas: number;
  percentualreceita: number;
  percentualvendas: number;
}

export interface ITopProdutoVendidoItem {
  idproduto: string;
  descricao: string;
  ean: string;
  quantidade: number;
  valorvendido: number;
}

export interface ITopProdutoDevolvidoItem {
  idproduto: string;
  descricao: string;
  ean: string;
  quantidadedevolvida: number;
  devolucoes: number;
  valordevolvido: number;
}

export interface IDashboardVendasGraficos {
  intervalo: {
    datainicial: string;
    datafinal: string;
  };
  totais: {
    receita: number;
    vendas: number;
    ticketmedio: number;
  };
  evolucao: IEvolucaoVendasItem[];
  formapagamento: IFormaPagamentoItem[];
  topProdutosVendidos: ITopProdutoVendidoItem[];
  topProdutosDevolvidos: ITopProdutoDevolvidoItem[];
}


const getAll = async (page = 1, dataInicial = '', dataFinal = '', filter = '', tipo = '', limit = Environment.LIMITE_DE_LINHASSMALL): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/vendas?page=${page}&limit=${limit}&tipo=${tipo}&filter=${filter}&datainicial=${dataInicial}&datafinal=${dataFinal}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 10),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const getAllTotaisComissao = async (dataInicial: string, dataFinal: string, page = 1,): Promise<TotalCountComissao | Error> => {
  try {
    const urlRelativa = `/dashboardcomissao?page=${page}&limit=${10}&datainicial=${dataInicial}&datafinal=${dataFinal}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        tipovenda: data.tipovenda,
        totais: data.totais,
        vendedor: data.vendedor,
        comissao: data.comissao || [],
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getAllVendasComissao = async (
  dataInicial: string,
  dataFinal: string,
  page = 1,
  limit = 10,
): Promise<IListagemVendasComissao | Error> => {
  try {
    const urlRelativa = `/listagemvendas?page=${page}&limit=${limit}&datainicial=${dataInicial}&datafinal=${dataFinal}`;
    const { data, headers } = await Api.get(urlRelativa);

    if (data) {
      console.log('data', data);
      return {
        vendas: data.vendas,
        totalCount: Number(
          headers['x-total-count'] || 0,
        ),
      };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {
        const errorMessage =
          axiosError.response.data.errors?.default ||
          'Erro desconhecido';

        return new Error(errorMessage);
      }

      if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      }

      return new Error(axiosError.message);
    }

    return new Error('Erro inesperado');
  }
};

const getAllGraficoComissao = async (
  dataInicial: string,
  dataFinal: string,
  page = 1,
  limit = 10,
): Promise<IGraficoVendasComissao | Error> => {
  try {
    const urlRelativa = `/graifcocomissao?page=${page}&limit=${limit}&datainicial=${dataInicial}&datafinal=${dataFinal}`;

    const { data } = await Api.get(urlRelativa);

    if (data) {
      return {
        grafico: data.grafico

      };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {
        const errorMessage =
          axiosError.response.data.errors?.default ||
          'Erro desconhecido';

        return new Error(errorMessage);
      }

      if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      }

      return new Error(axiosError.message);
    }

    return new Error('Erro inesperado');
  }
};
const getDashboardVendas = async (dataInicial: string, dataFinal: string): Promise<IDashboardVendas | Error> => {
  try {
    const urlRelativa = `/dashboardvendas?datainicial=${dataInicial}&datafinal=${dataFinal}`;

    const { data } = await Api.get(urlRelativa);

    if (data) {
      return {
        vendedores: data.vendedores || [],
        tipovenda: data.tipovenda,
        grafico: data.grafico || [],
      };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {
        const errorMessage =
          axiosError.response.data.errors?.default ||
          'Erro desconhecido';

        return new Error(errorMessage);
      }

      if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      }

      return new Error(axiosError.message);
    }

    return new Error('Erro inesperado');
  }
};

const getDashboardVendasGraficos = async (
  periodo: TPeriodoDashboardVendas = 'mensal',
  ano?: number,
  iduser?: string,
): Promise<IDashboardVendasGraficos | Error> => {
  try {
    let urlRelativa = `/dashboardvendasgraficos?periodo=${periodo}`;

    if (ano) urlRelativa += `&ano=${ano}`;
    if (iduser) urlRelativa += `&iduser=${iduser}`;

    const { data } = await Api.get(urlRelativa);

    if (data) {
      const converterTopVendido = (item: any): ITopProdutoVendidoItem => ({
        idproduto: item.idproduto,
        descricao: item.descricao,
        ean: item.ean,
        quantidade: Number(item.quantidade || 0),
        valorvendido: Number(item.valorvendido || 0),
      });

      const converterTopDevolvido = (item: any): ITopProdutoDevolvidoItem => ({
        idproduto: item.idproduto,
        descricao: item.descricao,
        ean: item.ean,
        quantidadedevolvida: Number(item.quantidadedevolvida || 0),
        devolucoes: Number(item.devolucoes || 0),
        valordevolvido: Number(item.valordevolvido || 0),
      });

      return {
        intervalo: data.intervalo,
        totais: {
          receita: Number(data.totais?.receita || 0),
          vendas: Number(data.totais?.vendas || 0),
          ticketmedio: Number(data.totais?.ticketmedio || 0),
        },
        evolucao: data.evolucao || [],
        formapagamento: (data.formapagamento || []).map((item: any) => ({
          forma: item.forma,
          receita: Number(item.receita || 0),
          vendas: Number(item.vendas || 0),
          percentualreceita: Number(item.percentualreceita || 0),
          percentualvendas: Number(item.percentualvendas || 0),
        })),
        topProdutosVendidos: (data.topProdutosVendidos || []).map(converterTopVendido),
        topProdutosDevolvidos: (data.topProdutosDevolvidos || []).map(converterTopDevolvido),
      };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {
        const errorMessage =
          axiosError.response.data.errors?.default ||
          'Erro desconhecido';

        return new Error(errorMessage);
      }

      if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      }

      return new Error(axiosError.message);
    }

    return new Error('Erro inesperado');
  }
};

const getById = async (id: string): Promise<IgetMovimento | Error> => {
  try {
    const { data } = await Api.get(`/vendas/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const create = async (dados: IDetalheMovimento, dadositens: IitensMovimentoDialog[], faturamento: IParcelasFaturamento[]): Promise<string | Error> => {
  try {
    const dadosExtraidos = dadositens.map(({ descricao, filtro, marca, referencia, ean, idref, localizado, original, status, ...restoDoObjeto }) => ({
      idref: idref === '' ? null : idref,
      idmov: dados.idmov,
      tipo: 2, ...restoDoObjeto
    }));
    const Pfaturamento = faturamento.map(({ qtdparcelas, ...restoDoObjeto }) => ({ idmov: dados.idmov, ...restoDoObjeto }));
    const { numero, ...dadosIDetalheEntrada } = dados;
    const dadosvenda = { tipo: 2, tipovenda: 'venda', ...dadosIDetalheEntrada, faturado: false };
    const { data } = await Api.post<IDetalheMovimento>('/vendas', [dadosvenda, dadosExtraidos, Pfaturamento]);
    if (Object.keys(data).length === 0) {
      return dados.idmov;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const imprimirNota = async (id: string): Promise<Blob | Error> => {
  try {
    const response = await Api.get(`/geradanfnfce/${id}`, {
      responseType: 'blob',
    });
    if (response.data) {
      return response.data;
    }
    return new Error('Erro ao gerar a nota.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateById = async (id: string, dados: IDetalheMovimento, dadositens: IitensMovimentoDialog[], iddeletados: IItensids[], faturamento: IParcelasFaturamento[]): Promise<void | Error> => {
  try {
    
    const dadosExtraidos = dadositens.map(({ descricao, filtro, marca, referencia, ean, original, localizado, status, ...restoDoObjeto }) => ({ idmov: id, tipo: 2, ...restoDoObjeto }));
    const { ...dadosIDetalheEntrada } = dados;
    const dadosvenda = { ...dadosIDetalheEntrada, faturado: false };
    const Pfaturamento = faturamento.map(({ qtdparcelas, ...restoDoObjeto }) => ({ idmov: id, ...restoDoObjeto }));
    await Api.put(`/vendas/${id}`, [dadosvenda, dadosExtraidos, iddeletados, Pfaturamento]);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateByIdDevolucao = async (id: string, dados: IDetalheMovimento, dadositens: IitensMovimentoDialog[], iddeletados: IItensidsDevolucao[], faturamento: IParcelasFaturamento[]): Promise<void | Error> => {
  try {
    const dadosExtraidos = dadositens.map(({ descricao, filtro, marca, referencia, ean, original, localizado, status, ...restoDoObjeto }) => ({ idmov: id, tipo: 2, ...restoDoObjeto }));
    const dadosIDetalheEntrada = {
      ...dados,
      numero: Number(dados.numero)
    };
    const dadosEntrada = { ...dadosIDetalheEntrada };
    const Pfaturamento = faturamento.map(({ qtdparcelas, ...restoDoObjeto }) => ({ idmov: id, ...restoDoObjeto }));
    await Api.put(`/vendasdevolucao/${id}`, [dadosEntrada, dadosExtraidos, iddeletados, Pfaturamento]);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponsedevolucao>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data?.errors || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/vendas/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const deleteByIdDevolucao = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/vendacancelamento/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const Impressao = async (id: string): Promise<IgetImpressao | Error> => {
  try {
    const { data } = await Api.get(`/vendasimpressao/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
export const VendasService = {
  getAll,
  create,
  updateByIdDevolucao,
  getAllGraficoComissao,
  getAllTotaisComissao,
  getAllVendasComissao,
  getDashboardVendas,
  getDashboardVendasGraficos,
  deleteByIdDevolucao,
  getById,
  imprimirNota,
  updateById,
  Impressao,
  deleteById,
};